<template>
  <v-card class="pa-6">
    <div class="d-flex align-center">
      <v-spacer></v-spacer>
      <h2 class="ml-12">{{ isEditing ? 'Atualizar' : 'Novo' }} Ponto</h2>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close')" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-divider class="mt-2 mb-3"></v-divider>

    <v-form ref="form">
      <v-row class="ma-0" dense>
        <v-col cols="12">
          <label>Ponto</label>
          <v-text-field
            type="number"
            v-model="range.range"
            hide-details="auto"
            :disabled="loading"
            placeholder="Digite a ponto"
            outlined
            class="primary-input"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <div class="d-flex px-1 mt-3">
      <v-spacer></v-spacer>
      <v-btn
        class="primary-button mr-0"
        depressed
        :loading="loading"
        @click="submit"
      >
        {{ isEditing ? 'Atualizar' : 'Adicionar' }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'

export default {
  name: 'ManageRangeRange',

  props: {
    selectedRange: Object,
    parameterId: Number,
  },

  data() {
    return {
      loading: false,
      range: {},
      apiService: new ApiService(),
      isEditing: false,
    }
  },

  created() {
    this.range.parameterId = this.parameterId

    if (this.selectedRange) {
      this.range = { ...this.selectedRange }
      this.isEditing = true
    }
  },

  methods: {
    submit() {
      if (!this.$refs.form.validate()) return

      this.range.range = this.range.range.toString().replace(',', '.')

      if (this.isEditing) this.edit()
      else this.add()
    },

    add() {
      this.loading = true

      this.apiService
        .post('calibration/v2/template/parameter/range', this.range)
        .then(() => {
          this.$toast.success('Métrica adicionada com sucesso!')
          this.loading = false
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },

    edit() {
      this.loading = true

      this.apiService
        .put('calibration/v2/template/parameter/range', this.range)
        .then(() => {
          this.$toast.success('Métrica adicionada com sucesso!')
          this.loading = false
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style></style>
